/**
 * DOM ids for the redesigned Account Settings tiles that other surfaces deep
 * link to with a `#fragment`.
 *
 * These are a CONTRACT, not local detail — renaming one silently breaks every
 * inbound link, and nothing in the type system connects the two sides. Both the
 * tile that renders the id and the page that builds the URL import from here so
 * a rename is at least a single edit.
 *
 * CAVEAT: the tiles these point at only render where
 * `isUpdatedPhysicalCardSettingsEnabled` is true — as of EX-40599 that is
 * `show_updated_physical_card_settings` OR the server's
 * `VIEW_PHYSICAL_CARD_MANAGEMENT` demo-enrollment verdict, so a demo-enrolled
 * org resolves these anchors with the flag off. Where neither holds, Account
 * Settings renders the legacy boxes, which have no equivalent tile — the
 * fragment then resolves to nothing and the browser simply stays at the top of
 * the page. That degradation is intentional (the link still lands on the right
 * tab), but it means a deep link is only as good as that gate.
 */
export const settingsAnchors = {
  /** The Spend Limit tile — target of "Adjust limit" on the card Overview. */
  spendLimit: 'card-settings-spend-limit',
  /** The Card settings tile — target of "Manage in Controls & Settings" on the card Overview. */
  cardSettings: 'card-settings-card-details',
} as const
